import React, { useEffect, useRef, useState } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import './NavBar.scss';
import { ReactComponent as LogoImage } from '../../assets/images/logo.svg';
import { ReactComponent as QuestionImage } from '../../assets/images/questionImage.svg';
import { useNavigate } from 'react-router-dom';
import { Popover, ArrowContainer } from 'react-tiny-popover';
import useUserStore from 'zustands/useUserStore';
import useStoreStore from 'zustands/useStoreStore';
import useLogout from 'hooks/useLogout';
import { CgMenu } from 'react-icons/cg';

type Props = {};

let LOCATION = '';

const NavBar: React.FC<Props> = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const { userToken, setManagerInfo, userType, subscribePlanName, userId } = useUserStore();

  const { storeSeq, setStoreInfo } = useStoreStore();

  const logoutFn = useLogout();

  const [isPopoverOpen, setIsPopoverOpen] = useState<boolean>(false);

  const onAccountSettingsClick = () => {
    navigate(`/account-settings`);
  };

  const onPayInfoClick = () => {
    navigate(`/payment-info`);
  };

  const onHelpClick = () => {
    navigate(`/help`);
  };

  const onPaymentSettingsClick = () => {
    navigate(`/payment`);
  };

  return (
    <div className="navBarComponent">
      <div className="logoContainer">
        <LogoImage />
        {storeSeq !== '' && (
          <>
            <div className="divider"></div>
            <button
              className="businessSelectButton"
              onClick={() => {
                setManagerInfo({
                  empSeq: 0,
                  payShow: false,
                  storePayShow: false,
                  otherPayShow: false,
                  calendarEdit: false,
                  recievePush: false,
                });
                setStoreInfo({ storeSeq: '', storeName: '', storeSeqNumber: 0 });
                navigate(`/business-establishment-choice`);
              }}>
              <strong className="buttonText">사업장 선택</strong>
            </button>
          </>
        )}
      </div>
      {userToken && userToken.length > 0 && (
        <>
          {/* button  */}

          {/* Flex box for spacing and right elements */}
          <div className="flexedRightContainer">
            {userType === '1' && userId && userId !== '01999999969' && (
              <>
                <div className="daysLeftContainer">{subscribePlanName}플랜 이용 중 입니다.</div>
                <div className="shopsolPaymentButtonContainer" onClick={onPaymentSettingsClick}>
                  샵솔결제
                </div>
              </>
            )}

            <div className="questionMarkContainer" onClick={onHelpClick} title="도움말">
              <QuestionImage />
            </div>
            <Popover
              isOpen={isPopoverOpen}
              positions={['bottom']}
              padding={5}
              onClickOutside={() => setIsPopoverOpen(false)}
              content={({ position, childRect, popoverRect }) => (
                <ArrowContainer
                  position={position}
                  childRect={childRect}
                  popoverRect={popoverRect}
                  arrowColor={'#e9e9e9'}
                  arrowSize={5}
                  arrowStyle={{ zIndex: 100, top: '1px' }}
                  className="popover-arrow-container"
                  arrowClassName="popover-arrow">
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      position: 'relative',
                      right: '20px',
                      minWidth: '100px',
                      border: '1px solid #E9E9E9',
                      borderRadius: '8px',
                      backgroundColor: 'white',
                      boxShadow: '2px 2px 20px rgba(0, 0, 0, 0.06)',
                      overflow: 'hidden',
                    }}
                    onClick={() => setIsPopoverOpen(!isPopoverOpen)}>
                    <button className="navBarMenuItem" onClick={onAccountSettingsClick}>
                      계정설정
                    </button>
                    {userType === '1' && userId !== '01999999969' && (
                      <button className="navBarMenuItem" onClick={onPayInfoClick}>
                        결제관리
                      </button>
                    )}
                    <button className="navBarMenuItem" onClick={logoutFn}>
                      로그아웃
                    </button>
                  </div>
                </ArrowContainer>
              )}>
              <button className="profileImageContainer" onClick={() => setIsPopoverOpen(!isPopoverOpen)}>
                <CgMenu size={26} />
                {/* <strong>{userName?.substring(0, 1)}</strong> */}
              </button>
            </Popover>
          </div>
        </>
      )}
    </div>
  );
};

export default NavBar;
